const PARENT_BY_PROVIDER = {
  openai: 'OpenAI',
  anthropic: 'Anthropic',
  vertex: 'Google',
  ollama: 'Ollama',
};

/**
 * Buckets a flat catalog list into openai | anthropic | vertex | ollama with stable parent labels.
 * @param {Array<{ id: string, name?: string, provider?: string, parent?: string }>} flat
 * @returns {Record<'openai'|'anthropic'|'vertex'|'ollama', Array>}
 */
export function groupChatModelsByProvider(flat) {
  if (!Array.isArray(flat)) {
    return { openai: [], anthropic: [], vertex: [], ollama: [] };
  }
  const out = {
    openai: [],
    anthropic: [],
    vertex: [],
    ollama: [],
  };
  for (const m of flat) {
    const p = String(m?.provider || '').toLowerCase();
    if (!out[p]) continue;
    const parent = m.parent || PARENT_BY_PROVIDER[p];
    out[p].push({ ...m, parent });
  }
  return out;
}
